import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext from '~/context/common/UserContext';

export default function useSendViewedEvent(eventName: string) {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    userState: { isLoaded: isUserLoaded }
  } = useContext(UserContext);

  useEffectOnce(
    () => {
      trackEvent(eventName);
    },
    [eventName, trackEvent],
    isUserLoaded
  );
}
